<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   
           </div>
        </div>
    </div>
    <div class="membership-hero-section cf">
        <div class="container">
            <!-- <div class="membership-hero-detail cf">
                <div class="membership-new-top-section">
                    <iframe src="https://player.flipsnack.com?hash=Qzg3QkVDQkJEQzkrY3A4YjNqdW83aw==" width="100%" height="480" seamless="seamless" scrolling="no" frameBorder="0" allowFullScreen allow="autoplay; clipboard-read; clipboard-write"></iframe>
                </div>             
            </div> -->
            <div class="membership-new-tab-section">
                <div class="membership-new-tab-title">
                    <h4>please find the 2025 Membership categories and FAQ below</h4>
                </div>
                <div class="membership-new-tab-list">
                    <ul >
                        <!-- <li><a href="javascript:void(0)" class="courses-name active" id="membership-categories1">DAVID GOWER EXECUTIVE CLUB</a></li> -->
                        <li *ngFor="let memeber of membershipList; let i = index"><a href="javascript:void(0)"  [ngClass]="{ active: i == 0 }" class="courses-name"  id="membership-categories{{memeber?.membership_id}}">{{memeber?.title}}</a></li>
                        <!-- <li><a href="javascript:void(0)" class="courses-name" id="membership-categories3">CLUB MEMBERSHIP</a></li> -->
                        <!-- <li><a href="javascript:void(0)" class="courses-name" id="membership-categories4">JUNIOR MEMBERSHIP PLUS</a></li> -->
                        <!-- <li><a href="javascript:void(0)" class="courses-name" id="membership-categories5">JUNIOR MEMBERSHIP </a></li> -->
                        <!-- <li><a href="javascript:void(0)" class="courses-name" id="membership-categories6">WHITE BALL PASS  </a></li> -->
                        <!-- <li><a href="javascript:void(0)" class="courses-name" id="membership-categories7">CAR PARKING PASSES</a></li> -->
                        <!-- <li><a href="javascript:void(0)" class="courses-name" id="membership-categories8">CAR PARKING PASSES - FULL SEASON</a></li> -->
                        <li><a routerLink="/membership-faqs" >FAQs</a></li>
                    </ul>
                </div>
                <!--<div class="membership-new-title-tab">
                    <p>*prices frozen until Christmas</p>
                </div>-->
                <div class="membership-new-tab-detail">
                    <!-- <div class="membership-new-tab-detail-box course-main-content active" id="membership-categories1-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">David Gower Executive Club </h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3><span>From</span>£525</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left">
                                <p>Exclusive access into the superb David Gower Suite for:  </p>
                                <ul>
                                    <li>All seven home LV= Insurance County Championship fixtures</li>                
                                    <li>All four home One Day Cup group stage fixtures </li> 
                                    <li>All seven home Vitality Blast group stage fixtures </li> 
                                    <li>On-site parking for all domestic home fixtures</li> 
                                    <li>Complimentary guest tickets into the David Gower Suite during the season </li>
                                    <li>Exclusive events, hospitality, player and coach visits and behind the scenes access. </li>                          
                                    <li>Membership lanyard and holder, and pen.</li>
                                    <li>1 free meal in the Charles Palmer on a County Championship fixture.</li>
                                </ul>
                            </div>
                            <div class="membership-new-tab-btn">
                                <a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/4?position=0" target="_blank">BUY</a>
                            </div>
                        </div>
                    </div> -->
                    <div *ngFor="let memeber of membershipList; let i = index" [ngClass]="{ active: i == 0 }" class="membership-new-tab-detail-box course-main-content "  id="membership-categories{{memeber?.membership_id}}-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">{{memeber?.title}}</h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3><span>From</span>{{memeber?.subtitle}}</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left" >
                                
                                <div class="membership-new-tab-left-new" [innerHTML]="memeber?.description"></div>
                                <!-- <ul >
                                    <li>Entry to all seven home LV= Insurance County Championship fixtures</li>
                                    <li>Entry to all four home One Day Cup group stage fixtures</li>
                                    <li>Entry to all seven home Vitality Blast group stage fixtures</li>
                                    <li>Admission to all Leicestershire Women’s and international fixtures</li>
                                    <li>Four complimentary guest tickets to a day’s play of an LV= Insurance County Championship fixture during the season</li>
                                    <li>Priority access to tickets to a home One Day Cup Quarter or Semi-Final </li>
                                    <li>Priority access to tickets to a home Vitality Blast Quarter-Final</li>
                        
                                </ul> -->
                            </div>
                            <div class="membership-new-tab-btn" *ngIf="memeber?.redirect_url != ''">
                                <a href="{{memeber?.redirect_url}}" target="_blank">{{memeber?.button_name}}</a>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="membership-new-tab-detail-box course-main-content " id="membership-categories3-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">Club Membership </h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3><span>From</span>£175</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left">
                                <ul>
                                    <li>Entry to all seven home LV= Insurance County Championship fixtures</li>
                                    <li>Entry to all four home One Day Cup group stage fixtures</li>
                                    <li>Invitation to Members’ Marquee Days for selected LV= Insurance County Championship fixtures during the 2023 season</li>
                                    <li>Four complimentary guest tickets to a day’s play of an LV= Insurance County Championship fixture during the season</li>
                                    <li>Priority access to tickets to a home One Day Cup Quarter or Semi-Final</li>
                                    <li>Invitation to Members’ events during the 2023 season, including the Members’ Annual Dinner and Members’ Forum</li>
                                    
                                </ul>
                            </div>
                            <div class="membership-new-tab-btn">
                                <a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/1?position=0" target="_blank">BUY</a>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="membership-new-tab-detail-box course-main-content " id="membership-categories4-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">Junior Membership Plus </h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3><span>From</span>£15</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left">
                                <ul>
                                    <li>Entry to all seven home LV= Insurance County Championship fixtures</li>
                                    <li>Entry to all four home One Day Cup group stage fixtures</li>
                                    <li>Entry to all seven home Vitality Blast group stage fixtures</li>
                                    <li>Priority access to tickets to a home One Day Cup Quarter or Semi-Final</li>
                                    <li>Priority access to tickets to a home Vitality Blast Quarter-Final</li>
                                    <li>Discount on Summer Coaching Camps</li>

                                </ul>
                            </div>
                            <div class="membership-new-tab-btn">
                                <a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/19?position=0" target="_blank">BUY</a>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="membership-new-tab-detail-box course-main-content " id="membership-categories5-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">Junior Membership</h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3>FREE</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left">
                                <p>Take out everything and replace with below: </p>
                                <ul>
                                    <li>Access to all home County Championship fixtures in the season</li>
                                    <li>Priority Access to a home quarter or semi final fixture (should the Leicestershire foxes qualify)</li>
                                    <li>Priority Access to a home Vitality Blast quarter final (should the Leicestershire foxes qualify)</li>
                                    <li>all Women games (RHFT/CEC)</li>
                                    <li>Free access to Family Funday – Metro Bank One Day Cup fixture</li>
                                    <li>10% off Summer Camps and Club Merchandise</li>
                                    <li>Half Term activities (TBC)</li>
                                </ul> 
                            </div>
                            <div class="membership-new-tab-btn">
                                <a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/20?position=0" target="_blank">BUY</a>
                            </div>
                        </div>
                    </div>
                    <div class="membership-new-tab-detail-box course-main-content " id="membership-categories6-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">White ball pass</h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3>£90</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left">
                                <ul>
                                    <li>Entry to all home group matches in the Metro Bank One Day Cup </li>
                                    <li>Entry to all home group matches in the Vitality Blast </li>
                                    <li>Entry to selected additional matches held at Uptonsteel County ground.</li>
                                    <li>10% discount on Club merchandise </li>
                                    <li>Discount on selected non-matchday events staged at the Uptonsteel County Ground </li>        
                                </ul>
                            </div>
                            <div class="membership-new-tab-btn">
                                <a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/29?position=0" target="_blank">BUY</a>
                            </div>
                        </div>
                    </div>
                    <div class="membership-new-tab-detail-box course-main-content " id="membership-categories7-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">Car Parking Pass</h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3>£100</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left">
                                <p>– LV= Insurance County Championship & One Day Cup</p>
                                <ul>
                                    <li>Limited Availability!</li>
                                    <li>Secure one of 100 available car park passes to reserve your space at the Uptonsteel County Ground on LV= Insurance County Championship & One Day Cup matchdays. Book early to avoid disappointment.</li>

                                </ul>
                            </div>
                            <div class="membership-new-tab-btn">
                                <a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/21?position=0" target="_blank">BUY</a>
                            </div>
                        </div>
                    </div> -->
                    <div class="membership-new-tab-detail-box course-main-content " id="membership-categories8-content">
                        <div class="membership-new-tab-detail-box_top">
                            <div class="ticket-outdoor-cinema-titel">
                                <h2 class="titel-name">Car Parking Pass </h2>
                            </div>
                            <div class="membership-new-tab-price">
                                <h3>£175</h3>
                            </div>
                        </div>
                        <div class="membership-new-tab-detail-box_bottom">
                            <div class="membership-new-tab-left">
                                <p>– Full Season</p>
                                <ul>
                                    <li>Limited Availability!</li>
                                    <li>Secure one of 100 available car park passes to reserve your space at the Uptonsteel County Ground on LV= Insurance County Championship, One Day Cup and T20 matchdays. Book early to avoid disappointment.</li>

                                </ul>
                            </div>
                            <div class="membership-new-tab-btn">
                                <a href="https://www.eticketing.co.uk/leicestershireccc/Memberships/Details/Index/22?position=0" target="_blank">BUY</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>         
        </div>
    </div>
    
</section><!-- page ends-->